<template>
  <div>
    <Counting_stock_edit/>
  </div>
</template>

<script>
import Counting_stock_edit from "@/components/adminArin/pos_system/warehouse/countingstock/Counting_stock_edit";
export default {
  name: "countingstockedit",
  components: {
    Counting_stock_edit
  }
}
</script>

<style scoped>

</style>
